module.exports = __webpack_public_path__ + "img/PGR_A05_back_diagonal_horizontal_en.70c144dc.png";